module.exports = "<div class=last-adjustment-tooltip><div class=over-arrow-box></div><%= appliedBy %><br><%= lastOptChangeDate %></div>";